import React, { Component } from 'react'
import { Query } from 'react-apollo'

export default (
  getQuery,
  key = 'data',
  mapData = (data) => data[Object.keys(data)[0]]
) => (WrappedComponent) =>
  class WithQuery extends Component {
    render() {
      return (
        <Query query={getQuery(this.props)}>
          {({ loading, error, data }) => (
            <div>
              {!error && (
                <WrappedComponent
                  {...this.props}
                  {...{
                    [`${key}Loading`]: loading,
                    [key]: !loading && mapData(data, key),
                  }}
                />
              )}
              {error && <h1>Error: {error.message}</h1>}
            </div>
          )}
        </Query>
      )
    }
  }



// WEBPACK FOOTER //
// ./src/containers/withQuery.js